import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Linkedin, Mail } from 'lucide-react';

// --- 1. DATA WITH PUBLIC_URL ---
const ugData = {
  overallHeads: [
    { 
      name: "Adwaaiit Pande", 
      role: "Overall Coordinator", 
      image: `${process.env.PUBLIC_URL}/ug/adwaiit.webp`,
      linkedin: "https://www.linkedin.com/in/adwaaiitpande24?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app", 
      email: "Adwaitrb@gmail.com" 
    },
    { 
      name: "Akshat Dhote", 
      role: "Overall Coordinator", 
      image: `${process.env.PUBLIC_URL}/ug/akshat.webp`,
      linkedin: "https://www.linkedin.com/in/akshat-dhote-9b1229241/", 
      email: "akshatd23@iitk.ac.in" 
    },
  ],
  heads: [
    { name: "Manan Jindal", role: "Research Head", image: `${process.env.PUBLIC_URL}/ug/manan.webp`, linkedin: "https://www.linkedin.com/in/manan-jindal-7830ba27a/", email: "mananjindalskj@gmail.com" },
    { name: "Kushal Jain", role: "Events Head", image: `${process.env.PUBLIC_URL}/ug/kushal.webp`, linkedin: "https://www.linkedin.com/in/kushal-jain-268651286/", email: "kushaljain453@gmail.com" },
    { name: "Oshita Bhongade", role: "Creatives Head", image: `${process.env.PUBLIC_URL}/ug/oshita.webp`, linkedin: "https://www.linkedin.com/in/oshita-bhongade11/", email: "oshitabhongade@gmail.com" },
    { name: "Kaushal Mehra", role: "Finance Head", image: `${process.env.PUBLIC_URL}/ug/kaushalmehra.webp`, linkedin: "https://www.linkedin.com/in/kaushalm23?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app", email: "koushalmehra1@gmail.com" },
    { name: "Mahir Jain", role: "Web Head", image: `${process.env.PUBLIC_URL}/ug/mahirjain.webp`, linkedin: "https://www.linkedin.com/in/mahirjain2006/", email: "mahirjain2006@gmail.com" }
  ],
  secretaries: [
    { name: "Aarzo", image: `${process.env.PUBLIC_URL}/ug/aarzo.webp` },
    { name: "Shivam Bansal", image: `${process.env.PUBLIC_URL}/ug/shivambansal.webp` },
    { name: "Aditya Kumar", image: `${process.env.PUBLIC_URL}/ug/aditya.webp` },
    { name: "Ahmad", image: `${process.env.PUBLIC_URL}/ug/ahmad.webp` },
    { name: "Amruth", image: `${process.env.PUBLIC_URL}/ug/amruth.webp` }, 
    { name: "Ashwin Singh", image: `${process.env.PUBLIC_URL}/ug/ashwin singh.webp` },
    { name: "Daksh Battula", image: `${process.env.PUBLIC_URL}/ug/daksh battula.webp` },
    { name: "Mayank Kumar", image: `${process.env.PUBLIC_URL}/ug/mayank kumar.webp` },
    { name: "Rohan Singhal", image: `${process.env.PUBLIC_URL}/ug/rohan singhal.webp` },
    { name: "Sahasra", image: `${process.env.PUBLIC_URL}/ug/sahasara.webp` },
    { name: "Sathwik Chintha", image: `${process.env.PUBLIC_URL}/ug/sathwik chintha.webp` },
    { name: "Shaily", image: `${process.env.PUBLIC_URL}/ug/shaily.webp` },
    { name: "Shashank", image: `${process.env.PUBLIC_URL}/ug/shashank.webp` },
    { name: "Shreya", image: `${process.env.PUBLIC_URL}/ug/shreya.webp` },
    { name: "Shriya Suravarapu", image: `${process.env.PUBLIC_URL}/ug/shriya sivarappu.webp` },
    { name: "Shrushti", image: `${process.env.PUBLIC_URL}/ug/shrushti.webp` },
    { name: "Srinivas Tejavath", image: `${process.env.PUBLIC_URL}/ug/srinivas tejawath.webp` },
    { name: "Trisha Shekhawath", image: `${process.env.PUBLIC_URL}/ug/trisha shekhawat.webp` },
    { name: "Utham", image: `${process.env.PUBLIC_URL}/ug/utha m.webp` },
    { name: "Utkarsh Singh", image: `${process.env.PUBLIC_URL}/ug/utkarsh singh.webp` },
    { name: "Vanshika", image: `${process.env.PUBLIC_URL}/ug/vanshika.webp` }
  ]
};

// --- SKELETON COMPONENT ---
const MemberSkeleton = ({ isSmall }) => (
  <div className={`bg-slate-200 animate-pulse rounded-2xl ${isSmall ? 'w-60 h-80' : 'w-80 lg:w-96 h-[28rem]'}`} />
);

// --- ANIMATION VARIANTS ---
const containerVariants = { hidden: { opacity: 0 }, visible: { opacity: 1, transition: { staggerChildren: 0.1 } } };
const itemVariants = { hidden: { y: 20, opacity: 0 }, visible: { y: 0, opacity: 1, transition: { duration: 0.5, ease: "easeOut" } } };

// --- MEMBER CARD ---
const MemberCard = ({ name, role, image, linkedin, email, isSmall = false }) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const cardHeight = isSmall ? 'h-80' : 'h-[28rem]';
  const cardWidth = isSmall ? 'w-60' : 'w-80 lg:w-96';

  return (
    <motion.div variants={itemVariants} whileHover={{ y: -10, scale: 1.02 }} className={`group relative rounded-2xl overflow-hidden shadow-2xl transition-all duration-300 ${cardWidth} ${cardHeight}`}>
      <div className="absolute -inset-0.5 bg-gradient-to-r from-cyan-500 to-blue-500 opacity-0 group-hover:opacity-40 blur-xl transition duration-500 z-0" />
      <div className="absolute inset-0 z-0 bg-slate-900">
        {!imageLoaded && image && <div className="absolute inset-0 bg-slate-800 animate-pulse" />}
        {image ? (
          <img src={image} alt={name} loading="lazy" onLoad={() => setImageLoaded(true)} className={`w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 ${imageLoaded ? 'opacity-100' : 'opacity-0'}`} />
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-slate-800 to-slate-900 text-slate-500 font-bold text-5xl">{name.charAt(0)}</div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/60 to-transparent opacity-90 z-10" />
      </div>
      <div className="absolute inset-0 z-20 flex flex-col justify-end p-6 text-center">
        <h3 className={`font-bold text-white drop-shadow-md ${isSmall ? 'text-xl' : 'text-3xl'}`}>{name}</h3>
        <p className={`font-medium mt-2 text-slate-200 drop-shadow-sm ${isSmall ? 'text-sm' : 'text-lg'}`}>{role}</p>
        {(linkedin || email) && (
          <div className="flex gap-4 mt-5 justify-center md:opacity-0 md:transform md:translate-y-4 md:group-hover:opacity-100 md:group-hover:translate-y-0 transition-all duration-300">
            {linkedin && <a href={linkedin} target="_blank" rel="noopener noreferrer" className="p-2 rounded-full bg-white/20 text-white hover:bg-white/40 backdrop-blur-sm transition-colors border border-white/10"><Linkedin size={20} /></a>}
            {email && <a href={`mailto:${email}`} className="p-2 rounded-full bg-white/20 text-white hover:bg-white/40 backdrop-blur-sm transition-colors border border-white/10"><Mail size={20} /></a>}
          </div>
        )}
      </div>
    </motion.div>
  );
};

// --- UGTeam COMPONENT ---
const UGTeam = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulated loading delay
    const timer = setTimeout(() => setIsLoading(false), 800);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-slate-50 relative overflow-x-hidden pt-24 pb-20">
      <div className="absolute inset-0 z-0 opacity-[0.4]" style={{ backgroundImage: 'radial-gradient(#cbd5e1 1px, transparent 1px)', backgroundSize: '30px 30px' }} />
      <div className="absolute top-0 left-0 w-96 h-96 bg-blue-300 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob"></div>
      <div className="absolute top-0 right-0 w-96 h-96 bg-cyan-300 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-2000"></div>

      <div className="container mx-auto px-6 relative z-10">
        <motion.div initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }} className="text-center mb-20 max-w-3xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-slate-900 via-blue-800 to-slate-900 mb-6 drop-shadow-sm py-2 leading-tight">Undergraduate Team</h1>
          <p className="text-slate-600 text-xl font-light">The minds and makers driving innovation at the undergraduate level.</p>
        </motion.div>

        <AnimatePresence mode="wait">
          {isLoading ? (
            <div key="skeleton-grid" className="space-y-24">
               <div>
                  <div className="h-10 w-64 bg-slate-200 rounded-full mb-12 animate-pulse" />
                  <div className="flex flex-wrap justify-center gap-10">
                    {[...Array(2)].map((_, i) => <MemberSkeleton key={i} />)}
                  </div>
               </div>
               <div>
                  <div className="h-10 w-64 bg-slate-200 rounded-full mb-12 animate-pulse" />
                  <div className="flex flex-wrap justify-center gap-10">
                    {[...Array(5)].map((_, i) => <MemberSkeleton key={i} />)}
                  </div>
               </div>
            </div>
          ) : (
            <motion.div key="actual-content" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
              <div className="mb-24">
                <motion.h2 initial={{ opacity: 0, x: -20 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} className="text-3xl font-bold text-slate-800 mb-12 flex items-center justify-center md:justify-start gap-4">
                  <span className="w-2 h-8 bg-yellow-400 rounded-full"></span>Overall Coordinators
                </motion.h2>
                <motion.div variants={containerVariants} initial="hidden" animate="visible" className="flex flex-wrap justify-center gap-10">
                  {ugData.overallHeads.map((m, i) => <MemberCard key={i} {...m} />)}
                </motion.div>
              </div>

              <div className="mb-24">
                <motion.h2 initial={{ opacity: 0, x: -20 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} className="text-3xl font-bold text-slate-800 mb-12 flex items-center justify-center md:justify-start gap-4">
                  <span className="w-2 h-8 bg-blue-600 rounded-full"></span>Team Heads
                </motion.h2>
                <motion.div variants={containerVariants} initial="hidden" animate="visible" className="flex flex-wrap justify-center gap-10">
                  {ugData.heads.map((m, i) => <MemberCard key={i} {...m} />)}
                </motion.div>
              </div>

              <div>
                <motion.h2 initial={{ opacity: 0, x: -20 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} className="text-3xl font-bold text-slate-800 mb-12 flex items-center justify-center md:justify-start gap-4">
                  <span className="w-2 h-8 bg-cyan-500 rounded-full"></span>Secretaries
                </motion.h2>
                <motion.div variants={containerVariants} initial="hidden" animate="visible" className="flex flex-wrap justify-center gap-6">
                  {ugData.secretaries.map((member, i) => <MemberCard key={i} name={member.name} role="Secretary" image={member.image} isSmall={true} />)}
                </motion.div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default UGTeam;